import { empty } from 'fp-ts/lib/Array';
import { Lazy } from 'fp-ts/lib/function';

export function constEmpty<A>(): Lazy<A[]> {
	return () => empty;
}

export type ArrayType<A> = A extends (infer E)[] ? E : never;
